var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-ploymer"},[(_vm.grayscaleStatus == _vm.NO)?_c('CommonPage'):_vm._e(),(_vm.grayscaleStatus == _vm.HAS)?_c('CommonGrayScale'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }